module.exports = __webpack_public_path__ + "img/hakuna_step02.ecaf0fd5.png";